import { useQuery } from 'react-query';
import getHistoryDetail from 'data/requests/getHistoryDetail';
import { Order } from 'model/order';

const useHistoryDetail = (id: string) => {
  const { data, isLoading } = useQuery<Order>(['history', id], () =>
    getHistoryDetail(id),
  );

  return { order: data, isLoading };
};

export default useHistoryDetail;
